export function ModalCloseButton({ onClose, disabled = false }: { onClose: () => void; disabled?: boolean }) {
  return (
    <button
      className="modal-close"
      type="button"
      onClick={onClose}
      disabled={disabled}
      aria-label="Close modal"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  );
}
